import AppContentContainer from '@components/app-content-container/AppContentContainer';
import AppGoogleMap from '@components/app-google-map/AppGoogleMap';
import { useTranslation } from 'next-i18next';
import React, { useCallback, useMemo, useState } from 'react';
import style from './AppLuckyOCB.module.scss';

type Props = {
    pageData: any;
    routerPath: string[];
};

export default function AppLuckyOCB({ pageData: { Content }, routerPath }: Props) {
    const [t] = useTranslation();
    const [selectedBranchIndex, setSelectedBranchIndex] = useState<number>();
    const branches = useMemo(() => {
        return (Content?.data as any[] | null)
            ?.filter((item) => {
                return item.enabled?.value === '1';
            })
            .map((item: any) => {
                return {
                    key: item.key,
                    name: item.branchId?.targetItem?.branchBasicInfo?.targetItem?.branchName?.value,
                    address:
                        item.branchId?.targetItem?.branchBasicInfo?.targetItem?.branchAddress
                            ?.value,
                    lat: parseFloat(item.branchId?.targetItem?.latitude?.value?.trim()),
                    lng: parseFloat(item.branchId?.targetItem?.longitude?.value.trim()),
                    records: (item.yearWinningRecord?.value as string | null)
                        ?.split(',')
                        .map((r: string) => parseInt(r.trim())),
                    enable: item.enabled?.value === '1',
                };
            });
    }, [Content?.data]);
    return (
        <AppContentContainer routerPaths={routerPath} title={Content?.pageTitle?.value}>
            <div className='p-3 md:p-6 flex flex-col items-stretch'>
                <h2
                    className='m-0'
                    dangerouslySetInnerHTML={{ __html: Content?.header?.value }}
                ></h2>
                <div className='w-full py-3'>
                    <AppGoogleMap
                        selectedIndex={selectedBranchIndex}
                        addressList={branches || []}
                        onSelectedChange={(index) => {
                            setSelectedBranchIndex(index);
                        }}
                    ></AppGoogleMap>
                </div>
                <div className='py-3 overflow-x-auto'>
                    <h3 dangerouslySetInnerHTML={{ __html: Content?.tableTitle?.value }}></h3>
                    <div className='overflow-x-auto'>
                        <table className={style['branch-table']}>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td className='min-w-[50px] md:min-w-[102px]'>
                                        {t('LuckOCB.BranchName')}
                                    </td>
                                    <td className='min-w-[120px]'>{t('LuckOCB.Address')}</td>
                                    {Content?.yearColumns?.value
                                        ?.split(',')
                                        .map((year: string, idx: number) => {
                                            return <td key={year + idx}>{year}</td>;
                                        })}
                                    <td>{t('LuckOCB.Total')}</td>
                                </tr>
                                {branches &&
                                    branches.map((b, index) => {
                                        return (
                                            <tr
                                                className={
                                                    selectedBranchIndex === index
                                                        ? style['selected-branch']
                                                        : ''
                                                }
                                                key={index}
                                                onMouseOver={() => {
                                                    setSelectedBranchIndex(index);
                                                }}
                                                onMouseOut={() => {
                                                    if (selectedBranchIndex === index) {
                                                        setSelectedBranchIndex(undefined);
                                                    }
                                                }}
                                            >
                                                <td>{index + 1}</td>
                                                <td>{b.name}</td>
                                                <td>{b.address}</td>
                                                {b.records &&
                                                    b.records.map((r, rIndex) => (
                                                        <td align='center' key={rIndex}>
                                                            {r || '-'}
                                                        </td>
                                                    ))}
                                                <td align='center'>
                                                    {b.records?.reduce((r1, r2) => r1 + r2)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>

                    <div
                        className='pt-3'
                        dangerouslySetInnerHTML={{ __html: Content?.tableFootnote.value }}
                    ></div>
                </div>
            </div>
        </AppContentContainer>
    );
}
